<div class="popup-close" mat-dialog-close>
  <svg viewBox="0 0 14 14">
    <use href="#close" />
  </svg>
</div>
<h1 mat-dialog-title class="popup-title"><span i18n>Choose the Source Type</span></h1>
<div mat-dialog-content>
  <div class="source-wrap">
    <div class="source-item" (click)="onSelect(types.LOCAL_VIDEO); (false)">
      <div class="source-icon">
        <svg viewBox="0 0 56 56">
          <use href="#video" />
        </svg>
      </div>
      <div>
        <div class="source-title"><span i18n>Local video</span></div>
        <div class="source-desc"><span i18n>Share a video file from your computer.</span></div>
      </div>
      <div class="source-arrow">
        <svg viewBox="0 0 7 12">
          <use href="#arrow_right" />
        </svg>
      </div>
    </div>
    <div class="source-item" (click)="onSelect(types.BACKGROUND_MUSIC); (false)">
      <div class="source-icon">
        <svg viewBox="0 0 56 56">
          <use href="#music" />
        </svg>
      </div>
      <div>
        <div class="source-title"><span i18n>Background music</span></div>
        <div class="source-desc"><span i18n>Add endless background music to your stream.</span></div>
      </div>
      <div class="source-arrow">
        <svg viewBox="0 0 7 12">
          <use href="#arrow_right" />
        </svg>
      </div>
    </div>
  </div>
</div>
